import React from "react";
import UserProfile from "../components/UserProfile";

function UserProfilePage() {
    return (
      <>
        <UserProfile />
      </>
    );
  };
  
export default UserProfilePage;
